import gql from "graphql-tag";

export const GET_TRANSLATIONS = gql`
	query GetTranslations {
		GetTranslations {
			en
			de
		}
	}
`;

export const GET_MISSING_KEYS = gql`
	query GetMissingKeysQuery($environment: String!) {
		GetMissingKeys(environment: $environment)
	}
`;
